module.exports = __webpack_public_path__ + "static/bg-8896ed2e4d1cf60fdb687d38782d3ac9.jpg";